import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useServiceRecurrence() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const useServiceRecurrenceQuery = (id) =>
        useQuery({
            queryKey: ["service-recurrence", id],
            queryFn: ({ queryKey }) => {
                const [, recurrenceId] = queryKey;
                return axiosPrivate
                    .get(`service-recurrence/${recurrenceId}/`)
                    .then(r => r.data);
            },
            enabled: !!id,
        });

    const useServiceRecurrenceServiceQuery = (id) =>
        useQuery({
            queryKey: ["service-recurrence", "get-for-service", id],
            queryFn: ({ queryKey }) => {
                const [,, serviceId] = queryKey;
                return axiosPrivate
                    .get(`service-recurrence/${serviceId}/get-for-service/`)
                    .then(r => r.data);
            },
            enabled: !!id,
        });

    const serviceRecurrenceListQuery = useQuery({
        queryKey: ["service-recurrence", "list"],
        queryFn: () =>
            axiosPrivate
                .get("service-recurrence/")
                .then(r => r.data),
    });

    // MUTATIONS ------------------------------------------------------

    const createServiceRecurrenceMutation = useMutation({
        mutationFn: (data) =>
            axiosPrivate
                .post("service-recurrence/", data)
                .then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["service-recurrence"]);
        },
    });

    const updateServiceRecurrenceMutation = useMutation({
        mutationFn: ({ id, data }) =>
            axiosPrivate
                .patch(`service-recurrence/${id}/`, data)
                .then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["service-recurrence"]);
        },
    });

    const deleteServiceRecurrenceMutation = useMutation({
        mutationFn: (id) =>
            axiosPrivate
                .delete(`service-recurrence/${id}/`)
                .then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["service-recurrence"]);
        },
    });

    return {
        // queries
        useServiceRecurrenceQuery,
        serviceRecurrenceListQuery,
        useServiceRecurrenceServiceQuery,

        // mutations
        createServiceRecurrenceMutation,
        updateServiceRecurrenceMutation,
        deleteServiceRecurrenceMutation,
    };
}
